import React, { useState } from "react";
import styled from "styled-components";
import {
  FavoriteBorderOutlined,
  SearchOutlined,
  ShoppingCartOutlined,
} from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useDispatch } from "react-redux";
import { addProduct } from "../redux/cartRedux";
import { toast } from "react-hot-toast";

const Info = styled.div`
  opacity: 0;
  width: 100%;
  height: 100%;
  position: absolute;
  left: 0;
  top: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 3;
  transition: opacity 0.3s ease;
  color: black;
`;
const Container = styled.div`
  margin: 5px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1;
  min-width: 280px;
  height: 350px;
  background-color: #f3f9fd8f;
  position: relative;

  &:hover ${Info} {
    cursor: pointer;
    opacity: 1;
  }
`;
const Circle = styled.div`
  height: 200px;
  width: 200px;
  border-radius: 50%;
  background-color: white;
  position: absolute;
`;
const Image = styled.img`
  height: 80%;
  object-fit: contain;
  width: 100%;
  z-index: 2;
`;
const Icon = styled.div`
  width: 40px;
  height: 40px;
  cursor: pointer;
  background-color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 5px;
  transition: all 0.3s ease;
  &:hover {
    background-color: #e9f5f5;
    transform: scale(1.1);
  }
`;
const Product = ({ item }) => {

  const [quantity, setQuantity] = useState(1);
  const [product, setProduct] = useState(item);
  const [color, setColour] = useState(item.color[0]);
  const [size, setSize] = useState(item.size[0]);
  const dispatch = useDispatch();

  const handleClick = () => {
    // check if quantity is zero
    quantity && dispatch(addProduct({ ...product, quantity, size, color }));
    quantity && toast.success(`${product?.title} added to the cart`);
  };
  return (
    <Container>
      <Circle />
      <Image src={item.img} />
      <Info>
        <Icon onClick={handleClick}>
          <ShoppingCartOutlined />
        </Icon>
        <Icon>
          <Link to={`/product/${item._id}`} className="product">
            <SearchOutlined />
          </Link>
        </Icon>
        <Icon>
          <FavoriteBorderOutlined />
        </Icon>
      </Info>
    </Container>
  );
};

export default Product;
